import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
  Avatar,
  ThemeProvider,
  createTheme,
  Card,
  CardContent,
  CardMedia,
  Paper,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { ApptContext, ProviderSchedule ,EMRConfig} from "../../../../../../store"; //FB 8215
import useStyles from "../../../../../../css/styles_PE";
import {
  formatphone,
  GetAvailableSlotsByProvider,
  removePreRegistration,
} from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import ProviderSlots from "./ProviderSlots";
import { Box } from "@mui/material";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  To display the available schedules of the Provider
// FB  7882   12/26/2023  SK  Book Appointment Flow isn't working in EDGE and SAFARI browser, Desktop and Smartphones - Patient Portal
// FB  8024   01/03/2023  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8215   02/01/2024  GA  Portal - Provider images are wrong
// FB  8722   11/06/2024  DK  PE workflows enhancements


const Styles = makeStyles((theme) => ({
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  topBarItem_Day: {
    color: "#A8ABAE",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: ".1em",
    whiteSpace: "normal",
    fontSize: "10px",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    //width: "70%",
    fontSize: "smaller",
    //height: "25px",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    // FB 4574 DK - Added styling for increasing the icon size
    "& .MuiSvgIcon-root": {
      fontSize: "2rem",
    },
  },
  paper: {
    height: "auto",
    width: "auto",
    alignContent: "center",
    display: "flex",
    justifyContent: "center",
    border: "none",
    boxShadow: "none",
  },
  scrollbar: {
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:vertical": {
      backgroundColor: "rgba(0,0,0,.5)",
    },
  },
}));

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

interface DaySlot {
  dateLabel: string;
  hiddenDateValue: string;
}

export default function ProviderSchedules() {
  const classes = Styles();
  const [weekSlots, setWeekSlots] = useState<DaySlot[]>([]);
  const [dateCounter, setDateCounter] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [providerSchedules, setProviderSchedules] = useState<
    ProviderSchedule[]
  >([]);
  const [todayDate, setToday] = useState<boolean>(false);
  let tempdays: DaySlot[] = [];
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  //const { width, height } = windowDimensions;
  const [limited, setLimit] = useState<number>(7);
  const { state, dispatch } = useContext(ApptContext);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [websiteID, setWebsiteID] = useState(0); //FB 8215
  const styles = useStyles();

  const navigate = useNavigate();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      state.AppointmentDate = date;
      InsertPPLogs(
        "Changed the date to " + date.toDateString() + " in by provider flow",
        window.location.href,
        userName,
        ""
      );
    }
  };
  const handleGoBack = async () => {
    InsertPPLogs(
      "Clicked on Go Back - Slots page by provider flow",
      window.location.href,
      userName,
      ""
    );
    await removePreRegistration(state.SlotDetails.id);
    navigate(-1);
  };
  const handleProceed = () => {
    navigate("/user/bookappointment/provider/slots");
  };
  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  function constructDates(dtCounter: number = dateCounter) {
    let limit: number = dtCounter + 1;
    tempdays = [];
    if (window.innerWidth < 800) {
      limit = dtCounter + 1;
      setLimit(1);
    } else {
      limit = dtCounter + 7;
      setLimit(7);
    }
    for (dtCounter; dtCounter < limit; dtCounter++) {
      let currentDate = new Date();
      if (
        selectedDate !== null &&
        selectedDate.toDateString() !== currentDate.toDateString()
      ) {
        currentDate = new Date(selectedDate);
      }
      let days = currentDate.getDate() + dtCounter;
      //FB 7882-Begin
      let value = new Date(currentDate.setDate(days));
      let formattedcurrentDate = `${(value.getMonth() + 1).toString().padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}-${value.getFullYear()}`;
      tempdays.push({
        dateLabel: value.toString().substring(0, 10),
        hiddenDateValue: formattedcurrentDate,
      });
      //FB 7882-End
    }
    setWeekSlots(tempdays);
    setDateCounter(dtCounter);
    today();
  }

  function today() {
    let currentDate = new Date();
    let days = currentDate.getDate();
    let value = new Date(currentDate.setDate(days));
    let splittedDate = value.toLocaleDateString().split("/");
    if (
      `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}` ===
      tempdays[0].hiddenDateValue
    ) {
      setToday(true);
    } else setToday(false);
  }

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    constructDates(0);
    today();
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    if (selectedDate !== null) {
      constructDates(0);
    }
  }, [selectedDate]);

  useEffect(() => {
    //FB 8215 Begin
    let data = sessionStorage.getItem("EMRConfig");
    if(data!=null){
    let emrConfig = JSON.parse(data) as EMRConfig;
    setWebsiteID(emrConfig.WebsiteID);
    }
    //FB 8215 End
    //FB 8722
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;//FB 8024
    let customAppointmentAdmin = (sessionStorage.getItem("CustomAppointments"));//FB 8024
    if (weekSlots.length > 0) {
      setLoading(true);
      let temp: ProviderSchedule[] = [];
      //FB 8024 - Begin
      setTimeout(() => {
        (async () => {
          temp = await GetAvailableSlotsByProvider(
            limited,
            weekSlots[0].hiddenDateValue,
            state.Provider.ID,
            state.AppointmentType,
            0,
            appt_type_n
          );
          if (customAppointmentAdmin == "true") {
            for (const facility of temp) {
              for (const slotsDate of facility.SlotsDate) {
                if (slotsDate.ApptTypeSlots.length >= 1) {
                  slotsDate.Slots = slotsDate.ApptTypeSlots.slice();
                }
                else {
                  slotsDate.Slots = [""];
                }
              }
            }
            setProviderSchedules(temp);
            setLoading(false);
          }
          else {
            setProviderSchedules(temp);
            setLoading(false);
          }
          //FB 8024 - End
        })();
      }, 1000);
    }
  }, [weekSlots]);

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              className={styles.slotspage_Card}
              style={{ boxShadow: "none" }}
            >
              <CardMedia
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5%",
                }}
              >
                <Avatar
                  className={styles.slotspage_Avatar}
                  src={"/Images/Providers/"+websiteID+"/" + state.Provider.ID + ".jpg"} // FB 8215 -Added websiteID to the source path
                />
              </CardMedia>
              <CardContent>
                <Typography variant="h6">
                  <b>{state.Provider.Name}</b>
                </Typography>
                <Typography style={{ fontSize: "smaller" }}>
                  {state.Provider.JobTitle}
                </Typography>
                <Typography style={{ fontSize: "smaller" }}>
                  {state.Provider.Bio}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ display: window.innerWidth <= 768 ? "flex" : "none" }}
        >
          <Grid item xs={window.innerWidth === 768 ? 6 : 12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  id="dateByProvider"
                  className={`${classes.datepickerroot} ${classes.topBarItem}`}
                  fullWidth
                  inputVariant="standard"
                  orientation="portrait"
                  value={selectedDate}
                  label="Pick different date"
                  onChange={(date) => handleDateChange(date)}
                  format="MM/dd/yyyy"
                  minDate={new Date()}
                  initialFocusedDate={null}
                  minDateMessage="Date should not be in past"
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)" }}
          direction="row"
          alignContent="center"
          justify={window.innerWidth > 768 ? "flex-end" : "center"}
        >
          <Grid
            item
            sm={3}
            md={3}
            style={{ display: window.innerWidth > 768 ? "flex" : "none" }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  id="differentDate"
                  className={`${classes.datepickerroot} ${classes.topBarItem}`}
                  fullWidth
                  inputVariant="standard"
                  orientation="landscape"
                  value={selectedDate}
                  label="Pick different date"
                  onChange={(date) => handleDateChange(date)}
                  format="MM/dd/yyyy"
                  minDate={new Date()}
                  initialFocusedDate={null}
                  minDateMessage="Date should not be in past"
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2} sm={1} md={1}>
            {todayDate === false ? (
              <Tooltip title="Previous">
                <IconButton
                  aria-label="previous"
                  onClick={() =>
                    constructDates(
                      limited === 7 ? dateCounter - 14 : dateCounter - 2
                    )
                  }
                >
                  <ArrowBack
                    className={styles.navigationArrows}
                    fontSize="large"
                  />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
          </Grid>
          <Grid
            item
            xs={6}
            sm={7}
            md={7}
            style={{ display: "flex" }}
            direction="row"
            justify="center"
          >
            {weekSlots.map((ele: DaySlot, index: number) => {
              return (
                <Grid key={index} item sm={2} md={2}>
                  <Paper className={classes.paper}>
                    <span className={classes.topBarItem_Day}>
                      {ele.dateLabel.substring(0, 3)}
                    </span>
                  </Paper>
                  <Paper className={classes.paper}>
                    <span>{ele.dateLabel.substring(4, 10)}</span>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
          <Grid item xs={2} sm={1} md={1}>
            <Tooltip title="Next">
              <IconButton aria-label="next" onClick={() => constructDates()}>
                <ArrowForward
                  className={styles.navigationArrows}
                  fontSize="large"
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ display: "flex", minHeight: "40vh", marginTop: "15px" }}
          direction="row"
          alignContent="center"
          justify="center"
        >
          {loading ? (
            <Grid item xs={12} style={{ margin: "auto" }}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
              >
                <CircularProgress />
              </Grid>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              className={classes.scrollbar}
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              {providerSchedules?.length === 0 ||
              providerSchedules[0]?.Facility_N === 0 ? (
                <Grid item xs={12} style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <div className={classes.timeSlotItem}>
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        There are no online appointments available for this
                        provider. Please call{" "}
                        {formatphone(providerSchedules[0].Scheduling_Phone)} to
                        book an appointment.
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
              {providerSchedules && providerSchedules[0]?.Facility_N > 0 ? (
                providerSchedules.map(
                  (ele: ProviderSchedule, index: number) => {
                    return (
                      <ProviderSlots
                        ProviderSchedules={providerSchedules}
                        Limited={limited}
                        Index={index}
                        ProviderId={state.Provider.ID}
                        ProviderName={state.Provider.Name}
                        isLoading={setLoading}
                      />
                    );
                  }
                )
              ) : (
                <></>
              )}
            </Grid>
          )}
        </Grid>
        <Grid
          container
          spacing={2}
          className={styles.flexend_Grid}
          style={{ marginTop: 10, display: "flex" }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className={styles.flexend_Grid}
            style={{ marginTop: 10 }}
          >
            <Button
              onClick={handleGoBack}
              variant="contained"
              id="goBackByProvider"
              className={styles.navigationButton}
            >
              Go Back
            </Button>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
}
